// extracted by mini-css-extract-plugin
export default {"section-title":"SectionTitle_section-title__sLh8k","title":"SectionTitle_title__Y3coz","tag":"SectionTitle_tag__xxdSw"};